<template>
  <div class="app_cp">
    <div class="login-form">
      <div class="title">欢迎登录</div>
      <el-form :model="form" label-width="auto" style="max-width: 600px">
        <el-form-item>
          <el-input v-model="form.name" placeholder="请输入用户名或手机号">
            <template #prefix>
              <img class="icon" src="@/assets/login/user.png" alt="">
            </template>
          </el-input>
        </el-form-item>
        <el-form-item style="margin-top: 40px">
          <el-input v-model="form.password" placeholder="请输入密码" type="password">
            <template #prefix>
              <img class="icon" src="@/assets/login/lock.png" alt="">
            </template>
          </el-input>
        </el-form-item>
      </el-form>
      <div class="register" @click="goRegister">注册会员</div>
      <div class="btn" @click="submitLogin">登录</div>
    </div>
  </div>
</template>

<script setup>
import { reactive } from 'vue'
import { useRouter } from 'vue-router'
import { ElMessage } from 'element-plus'

const router = useRouter()
const form = reactive({
  name: '',
  password: '',
})
const submitLogin = () => {
  const users = JSON.parse(localStorage.getItem('users')) || [];
  const user = users.find(user =>
    (user.name === form.name || user.phone === form.name) && user.password === form.password
  );
  if (user) {
    // Login successful
    localStorage.setItem('pay', 'noPay');
    router.push('/index')
  } else if (form.name === '18771006250' && form.password === '123456') {
    localStorage.setItem('pay', 'paied');
    router.push('/index')
  } else {
    ElMessage({
      message: '账号或密码错误，请重新输入',
      type: 'warning',
    })
  }
}
const goRegister = () => {
  router.push('/register')
}
</script>

<style scoped lang="less">
.app_cp {
  background: url('@/assets/login/login_bg.jpg') no-repeat center center;
  background-size: 100% 100%;
  width: 100%;
  height: 100%;
  padding: 200px 344px 0 0;
  box-sizing: border-box;
  display: flex;
  justify-content: flex-end;

  .login-form {
    width: 498px;
    height: 437px;
    background: #F8F8F8;
    border-radius: 20px;
    padding: 45px 67px 61px 67px;
    box-sizing: border-box;
    text-align: center;

    .title {
      font-weight: 600;
      font-size: 28px;
      color: #3B3B3B;
      margin-bottom: 47px;
    }

    .icon {
      width: 20px;
      height: 20px;

    }
    .register {
      text-align: left;
      font-weight: 400;
      font-size: 14px;
      color: #393939;
      cursor: pointer;
    }
    .btn {
      margin-top: 20px;
      width: 364px;
      height: 45px;
      background: #1AB580;
      border-radius: 23px;
      display: flex;
      align-items: center;
      justify-content: center;
      font-weight: 400;
      font-size: 14px;
      color: #FFFFFF;
      cursor: pointer;
    }
  }
}

/deep/ .el-input__wrapper {
  width: 364px;
  height: 45px;
  background: #F2F2F2;
  border-radius: 23px;
}
</style>
